export var AccordionNavigationType;
(function(AccordionNavigationType) {
    AccordionNavigationType[AccordionNavigationType["MENU"] = 0] = "MENU";
    AccordionNavigationType[AccordionNavigationType["FOOTER"] = 1] = "FOOTER";
})(AccordionNavigationType || (AccordionNavigationType = {}));
